module.exports = __webpack_public_path__ + "static/media/U1-T2-4-5.7e364ae9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-4-5.svg
// module id = 594
// module chunks = 0